import { PeriodoIndisponibilidadeDto } from '@/models/dto/SincronizacaoDto';

export default class PeriodoIndisponibilidadeResource {
  dataInicio: Date;
  dataFim: Date;
  motivo: string;

  constructor(dto: PeriodoIndisponibilidadeDto) {
    this.dataInicio = new Date(dto.dataInicio);
    this.dataFim = new Date(dto.dataFim);
    this.motivo = dto.motivo;
  }
}
